import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { SlEnergy } from 'react-icons/sl';
import { TbFlame } from 'react-icons/tb';
import { MdOutlineOilBarrel, MdOutlineQuestionMark, MdOutlineSolarPower } from 'react-icons/md';


/**
 * AnlageCard
 * 
 * Is used to display basic information about customer Anlage in his
 * appartment. 
 * 
 * Is used in registration proces, in first step in InquaryPage.
 * 
 * @param {Anlage} props (Anlage) is passed from InquaryPage
 * @returns anlage card with basic info
 */
const AnlageCard = (props) => {

    const [showPlaceholders, setShowPlaceholders] = useState(true); // Shows placeholder card when data is not yet loaded

    let headerBg = ""; // header background of the card depending on type of anlage customer has

    // checks anlage type and changes header background color
    if (props.anlage) {
        if (props.anlage.x_studio_field_3eKe0 === "Strom") headerBg = '#a2c13f';
        if (props.anlage.x_studio_field_3eKe0 === "Gas") headerBg = '#3fbfbf';
        if (props.anlage.x_studio_field_3eKe0 === "Oil") headerBg = '#a2c13f';
    }

    // listen for changes in props.analge
    useEffect(() => {
        if (props.anlage === undefined) setShowPlaceholders(true);
        if (props.anlage) setShowPlaceholders(false);
    }, [props.anlage])


    // GUI
    return (
        <Col xs="12" xl="8">
            {!showPlaceholders ?
                (
                    <Card className="mt-3 shadow-lg rounded animate-slide-left" >
                        <Card.Header className="text-start text-white" style={{ background: headerBg }}>
                            <div className="border border-2 rounded-circle"
                                style={{ width: "54px", color: "white", paddingLeft: "10px", paddingTop: "10px", paddingRight: "10px", paddingBottom: "10px", display: "inline-block", float: "left" }}
                            >
                                {
                                    props.anlage.x_studio_field_3eKe0 === 'Strom' ?
                                        <SlEnergy size={30} />
                                    :
                                    props.anlage.x_studio_field_3eKe0 === 'Gas' ?
                                        <TbFlame size={30} />
                                    :
                                    props.anlage.x_studio_field_3eKe0 === 'Oil' ?
                                        <MdOutlineOilBarrel size={30} />
                                    :
                                    props.anlage.x_studio_field_3eKe0 === 'Strom-Einspeisung' ?
                                        <MdOutlineSolarPower size={30} />
                                    :
                                    <MdOutlineQuestionMark size={30} />
                                }
                            </div>
                            <div style={{ display: "inline-block", float: "left", paddingTop: "16px", marginLeft: "10px" }} className="hide-on-small">
                                Anlage: {props.anlage.x_studio_field_3eKe0}
                            </div>
                            <div style={{ display: "inline-block", float: "right", paddingTop: "5px" }}>
                                <span style={{ fontSize: "30px", fontWeight: "300" }}>{props.anlage.x_studio_field_mWMGR}</span>
                            </div>
                            <div className="hide-on-small" style={{ display: "inline-block", float: "right", paddingTop: "16px" }}>
                                Anlagenummer ENERGO: &nbsp;
                            </div>
                        </Card.Header>
                        <Card.Body className="text-start">
                            <p>Anlagenverwendung: &nbsp; <small className="text-muted">
                                {props.anlage.x_anlagenverwendung !== "" && props.anlage.x_anlagenverwendung !== "False"? props.anlage.x_anlagenverwendung : "-" }
                            </small></p>
                            <Row className="mt-3">
                                <Col className={props.anlage.x_zaehlpunktnummer_02 !== "False" ? 'border-right' : null} xs="12" md={props.anlage.x_zaehlpunktnummer_02 ? "6" : "12"} xl={props.anlage.x_zaehlpunktnummer_02 ? "6" : "12"}>
                                    {props.anlage.x_zaehlpunktnummer_02 !== "False" && props.anlage.x_zaehlpunktnummer_02 !== "" ?
                                        <p className="text-center" style={{ color: headerBg }}>Zählpunkt 1</p>
                                        :
                                        null
                                    }
                                    <p>Zählernummer &nbsp; <small className="text-muted">{props.anlage.x_zaehlernummer_01}</small></p>
                                    <p>Zählpunktnummer &nbsp; <small className="text-muted">{props.anlage.x_zaehlpunktnummer_01}</small></p>
                                    {props.anlage.x_lastprofil_01 !== "False" ? (
                                        <p>Lastprofil &nbsp; <small className="text-muted">{props.anlage.x_lastprofil_01}</small></p>
                                    ) : null}
                                </Col>
                                {props.anlage.x_zaehlpunktnummer_02 !== "False" && props.anlage.x_zaehlpunktnummer_02 !== "" ?
                                    <Col xs="12" md="6" xl="6">
                                        <p style={{ color: headerBg }} className="text-center">Zählpunkt 2</p>
                                        <p>Zählernummer &nbsp; <small className="text-muted">{props.anlage.x_zaehlernummer_02}</small></p>
                                        <p>Zählpunktnummer &nbsp; <small className="text-muted">{props.anlage.x_zaehlpunktnummer_02}</small></p>
                                        {props.anlage.x_lastprofil_02 !== "False" ? (
                                            <p>Lastprofil &nbsp; <small className="text-muted">{props.anlage.x_lastprofil_02}</small></p>
                                        ) : null}
                                    </Col>
                                    :
                                    null
                                }
                        </Row>
                        </Card.Body>
                    </Card>
                ) : null}
        </Col>
    )
}

export default AnlageCard;